/* tslint:disable */

/**
 */
export class Ramps {
    ID_RAMPS?: number;
    ID_EQUIP?: number;
    POSITION?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/ramps.ts